import React from 'react';
import styles from './style.module.scss';

export default function AiVideoAd() {
  return (
    <div className={styles.ai_tools_animation}>
      <img className={styles.ai_tools_animation_1} src={`${process.env.REACT_APP_BASENAME}/img/animations/animations-1-1.webp`} alt='' />
      <img className={styles.ai_tools_animation_2} src={`${process.env.REACT_APP_BASENAME}/img/animations/animations-1-2.webp`} alt='' />
      <img className={styles.ai_tools_animation_3} src={`${process.env.REACT_APP_BASENAME}/img/animations/animations-1-3.webp`} alt='' />
      <img className={styles.ai_tools_animation_4} src={`${process.env.REACT_APP_BASENAME}/img/animations/animations-1-4.webp`} alt='' />
      <img className={styles.ai_tools_animation_5} src={`${process.env.REACT_APP_BASENAME}/img/animations/animations-1-5.webp`} alt='' />
      <img className={styles.ai_tools_animation_6} src={`${process.env.REACT_APP_BASENAME}/img/animations/animations-1-6.webp`} alt='' />
      <svg
        className={styles.ai_tools_animation_7}
        width="103"
        height="27"
        viewBox="0 0 103 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_619_14188)">
          <rect x="6.48047" y="3.11719" width="90" height="15.2308" rx="2.68778" fill="white" />
          <rect
            x="6.59246"
            y="3.22918"
            width="89.776"
            height="15.0068"
            rx="2.57579"
            stroke="black"
            strokeWidth="0.223982"
            className={styles.ai_tools_animation_8}
          />
          <rect
            x="9.16797"
            y="5.84375"
            width="9.77344"
            height="9.77344"
            rx="4.88672"
            fill="black"
          />
          <rect
            x="12.8281"
            y="9.30469"
            width="0.814453"
            height="2.85059"
            rx="0.203613"
            fill="white"
            className={styles.ai_tools_animation_8}
          />
          <rect
            x="14.4609"
            y="9.30469"
            width="0.814453"
            height="2.85059"
            rx="0.203613"
            fill="white"
            className={styles.ai_tools_animation_8}
          />
          <rect
            x="22.1582"
            y="9.34766"
            width="19.3846"
            height="2.76923"
            rx="1.38462"
            fill="#CAD4DD"
          />
          <g clipPath="url(#clip0_619_14188)" className={styles.ai_tools_animation_8}>
            <path
              d="M64.0329 9.86446C64.0329 9.67665 63.8157 9.57224 63.669 9.68956L63.1132 10.1342C63.0934 10.1501 63.0687 10.1587 63.0433 10.1587H62.5462C62.4225 10.1587 62.3223 10.259 62.3223 10.3827V11.0752C62.3223 11.1989 62.4225 11.2992 62.5462 11.2992H63.0433C63.0687 11.2992 63.0934 11.3078 63.1132 11.3237L63.669 11.7683C63.8157 11.8857 64.0329 11.7813 64.0329 11.5934V9.86446Z"
              stroke="black"
              strokeWidth="0.358371"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M65.5694 9.38672C65.9257 9.74316 66.1259 10.2265 66.1259 10.7305C66.1259 11.2345 65.9257 11.7179 65.5694 12.0744M64.8984 10.0577C65.0766 10.2359 65.1767 10.4776 65.1767 10.7296C65.1767 10.9816 65.0766 11.2233 64.8984 11.4015"
              stroke="black"
              strokeWidth="0.358371"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <rect
            x="68.2578"
            y="10.2812"
            width="17.9186"
            height="0.895928"
            rx="0.447964"
            fill="#CAD4DD"
            className={styles.ai_tools_animation_8}
          />
          <rect
            x="68.2578"
            y="10.2812"
            width="13.2149"
            height="0.895928"
            rx="0.447964"
            fill="black"
            className={styles.ai_tools_animation_8}
          />
          <rect
            x="79.9102"
            y="8.9375"
            width="3.58371"
            height="3.58371"
            rx="1.79186"
            fill="black"
            className={styles.ai_tools_animation_8}
          />
          <rect
            x="89.8718"
            y="8.82683"
            width="3.80769"
            height="3.80769"
            rx="1.90385"
            stroke="black"
            strokeWidth="0.223982"
            className={styles.ai_tools_animation_8}
          />
          <circle
            cx="91.7759"
            cy="10.729"
            r="1.2095"
            fill="black"
            className={styles.ai_tools_animation_8}
          />
        </g>
        <defs>
          <filter
            id="filter0_d_619_14188"
            x="0.942007"
            y="0.347957"
            width="101.077"
            height="26.3074"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2.76923" />
            <feGaussianBlur stdDeviation="2.76923" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_619_14188" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_619_14188"
              result="shape"
            />
          </filter>
          <clipPath id="clip0_619_14188">
            <rect
              width="5.37557"
              height="5.37557"
              fill="white"
              transform="translate(61.5391 8.04297)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}
